import { styled } from 'styled-components';

import { Rarity, Sport } from '@sorare/core/src/__generated__/globalTypes';
import ticketsImg from '@sorare/core/src/assets/rewards/tickets.png';
import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import { CardBack } from '@sorare/core/src/components/card/Back';

import boxImg from '@sorare/gameplay/src/components/rewards/RewardBoxBanner/assets/crate.png';

const Box = styled.img`
  height: var(--quadruple-unit);
  &.limited {
    filter: sepia(1) hue-rotate(-10deg) saturate(3);
  }
  &.rare {
    filter: sepia(1) hue-rotate(-55deg) saturate(6);
  }
`;

const EmojiIcon = styled.div`
  font-size: var(--triple-unit);
`;

const EmojiBagIcon = styled(EmojiIcon)`
  font-size: var(--double-unit);
  margin-top: 8px;
`;

const TinyCardBack = styled(CardBack)`
  height: var(--quadruple-unit);
`;
const prizePool = [
  {
    category: 'Experiences',
    prizes: [
      {
        count: 1,
        displayName: '2x World Series',
        displayName2: 'Game Tickets',
        icon: (
          <Horizontal gap={0}>
            <Box src={ticketsImg} className="limited" />
            <EmojiBagIcon>👜</EmojiBagIcon>
          </Horizontal>
        ),
      },
      {
        count: 2,
        displayName: '2x Division Round',
        displayName2: 'Game Tickets',
        icon: <Box src={ticketsImg} />,
      },
    ],
  },

  {
    category: '46 Cards from Postseason Teams',
    type: 'cards',
    prizes: [
      {
        count: 1,
        rarity: 'super_rare',
        displayName2: 'Super Rare Card',
        displayName: 'Postseason Team',
        icon: (
          <TinyCardBack
            sport={Sport.BASEBALL}
            season="2024"
            rarity={Rarity.super_rare}
            tier={1}
          />
        ),
      },
      {
        count: 5,
        rarity: 'rare',
        displayName2: 'Rare Card',
        displayName: 'Postseason Team',
        icon: (
          <TinyCardBack
            sport={Sport.BASEBALL}
            season="2024"
            rarity={Rarity.rare}
          />
        ),
      },
      {
        count: 40,
        rarity: 'limited',
        displayName2: 'Limited Card',
        displayName: 'Postseason Team',
        icon: (
          <TinyCardBack
            sport={Sport.BASEBALL}
            season="2024"
            rarity={Rarity.limited}
          />
        ),
      },
    ],
  },

  {
    category: '75 Reward Boxes',
    prizes: [
      {
        count: 25,
        displayName: 'Premium',
        displayName2: 'Rare Box',
        icon: <Box src={boxImg} className="rare" />,
      },
      {
        count: 50,
        displayName: 'Premium',
        displayName2: 'Limited Box',
        icon: <Box src={boxImg} className="limited" />,
      },
    ],
  },
];

export default prizePool;
